export default __webpack_public_path__ + "static/media/brakekit-yellow.30c8f165.webp";